// setConfigDB
// setIsStoreOpen

export default {
  setConfigDB({ commit }, item) {
    commit('SET_CONFIG_DB', item);
  },
  setIsStoreOpen({ commit }, payload) {
    commit('SET_IS_STORE_OPEN', payload);
  },
}
